import { Prognosis } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/infrastructureEventModal/Prognosis";
import { BatchCommonInputProps } from "features/CenterContent/shared/operationalInformation/components/BatchTrainFormFieldWithCustomInput";
import { TrickFormHookGroupedTrainFormSchema } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/TrainInfoModal/types/formSchema";
import { FC, useEffect } from "react";
import { useFormContext } from "react-hook-form";

export const BatchPrognosis: FC<BatchCommonInputProps> = ({
  pathPrefix,
  numberOfGroups,
}) => {
  const { watch, setValue } =
    useFormContext<TrickFormHookGroupedTrainFormSchema>();

  const displayPath = `${pathPrefix}.0.trainForm` as const;
  const displayPrognosisTypeField =
    `${displayPath}.prognosisType.type` as const;
  const displayPrognosisType = watch(displayPrognosisTypeField);
  const displayPrognosisTimeField = `${displayPath}.prognosisTime` as const;
  const displayPrognosisTime = watch(displayPrognosisTimeField);
  useEffect(() => {
    // Update the other groups if prognosisType or prognosisTime changes
    for (let n = 1; n < numberOfGroups; n += 1) {
      const groupPath = `${pathPrefix}.${n}.trainForm` as const;
      const groupPrognosisTypeField =
        `${groupPath}.prognosisType.type` as const;
      setValue(groupPrognosisTypeField, displayPrognosisType);
      const groupPrognosisTimeField = `${groupPath}.prognosisTime` as const;
      setValue(groupPrognosisTimeField, displayPrognosisTime);
    }
  }, [displayPrognosisType, displayPrognosisTime]);
  return <Prognosis formPrefix={displayPath} />;
};
